// client/src/pages/Home.jsx
import React from 'react';
import Dashboard from '../components/Dashboard';

export default function Home() {
  return (
    <div style={{ padding: '1rem' }}>
      <Dashboard />
    </div>
  );
}
